import { PRIMARY, WHITE } from "../../constants";
import Spinner from "../Spinner";
import getStyles from "./AddressInput.styles";
import { Button } from "@dishopsaas/design-system";
import React from "react";
import { useAddressInputModal } from "./useAddressInputModal";
import { getOrderTypeLabel, isQrCode } from "../../utils";
import OrderTypeSwitch from "./components/OrderTypeSwitch";
import ShopsDropdownList from "./components/ShopsDropdownList";
import AddressSearchAutocompleteInput from "./components/AddressSearchAutocompleteInput/AddressSearchAutocompleteInput.view";
import AddressSelectionRadioButtons from "./components/AddressSelectionRadioButtons";
import { Typography, Box } from "@mui/material";
import CloseButton from "../CloseButton";

export default function AddressInputModal({
  shopId,
  onClose,
}: {
  shopId: string;
  onClose;
}) {
  const {
    showShopsDropdownList,
    handleAddressTypeSelection,
    handleOrderTypeSelection,
    handleAddressSelection,
    setTypedAddress,
    handleAddressInputFormControlError,
    handleShopSelection,
    errorMessage,
    isMobile,
    closestShops,
    isCustomerAddress,
    displayedSavedAddress,
    secondaryColor,
    orderTypes,
    orderTypeChoiceIndex,
    typedAddress,
    handleValidationButtonClick,
    shopDropdowListText,
    isFilledAddressValid,
    openShopsDropdownList,
    shouldRenderAddressSelectionRadioButton,
    orderType,
    hasErrorAddressMessage,
    shouldRenderAddressSearchInput,
    getShopsIsLoading,
    animatePlaceholder,
    isFirstTimeFetching,
    displayIsSavingSpinner,
    lastTypedAddressValidValue,
    isForcedNewAddressForDelivery,
    selectedAddress,
  } = useAddressInputModal(shopId);
  const styles = getStyles()
  const constructValidateButtonText = (orderType: string) =>
    `COMMANDER • ${getOrderTypeLabel(orderType)?.toUpperCase()}`;

  return (
    <div>
      <Box sx={styles.title}>
        <Typography variant="h5" sx={styles.welcomeTitle}>
          COMMANDER {getOrderTypeLabel(orderType)?.toUpperCase()}
        </Typography>
        <CloseButton onClick={onClose}></CloseButton>
      </Box>
      <div>
        <OrderTypeSwitch
          orderTypes={orderTypes}
          isMobile={isMobile}
          orderTypeChoiceIndex={orderTypeChoiceIndex}
          handleOrderTypeSelection={handleOrderTypeSelection}
          secondaryColor={secondaryColor}
        />
        {isFirstTimeFetching && !closestShops?.length ? (
          <div style={styles.loadingContainer}>
            <Spinner />
          </div>
        ) : (
          <>
            {!isQrCode() && (
              <>
                {shouldRenderAddressSelectionRadioButton && (
                  <AddressSelectionRadioButtons
                    isCustomerAddress={isCustomerAddress}
                    handleAddressTypeSelection={handleAddressTypeSelection}
                    getShopsIsLoading={getShopsIsLoading}
                    secondaryColor={secondaryColor}
                    savedAddress={displayedSavedAddress}
                    orderType={orderType}
                  />
                )}
                <div>
                  {shouldRenderAddressSearchInput && (
                    <div style={styles.addressContainer}>
                      {!displayedSavedAddress && (
                        <Typography variant="body1" sx={styles.label}>
                          Adresse {getOrderTypeLabel(orderType)}
                        </Typography>
                      )}
                      <AddressSearchAutocompleteInput
                        typedAddress={typedAddress}
                        setTypedAddress={setTypedAddress}
                        handleAddressSelection={handleAddressSelection}
                        handleAddressInputFormControlError={
                          handleAddressInputFormControlError
                        }
                        hasErrorAddressMessage={hasErrorAddressMessage}
                        showShopsDropdownList={showShopsDropdownList}
                        animatePlaceholder={animatePlaceholder}
                        isFilledAddressValid={isFilledAddressValid}
                        lastTypedAddressValidValue={lastTypedAddressValidValue}
                        customerAddress={displayedSavedAddress}
                      />
                    </div>
                  )}

                  <>
                    <ShopsDropdownList
                      showShopsDropdownList={showShopsDropdownList}
                      openShopsDropdownList={openShopsDropdownList}
                      hasErrorAddressMessage={hasErrorAddressMessage}
                      errorMessage={errorMessage}
                      getShopsIsLoading={getShopsIsLoading}
                      shopDropdowListText={shopDropdowListText}
                      closestShops={closestShops}
                      orderType={orderType}
                      handleShopSelection={handleShopSelection}
                    />
                  </>
                </div>
                {errorMessage && !getShopsIsLoading && hasErrorAddressMessage && (
                  <Typography variant="body1" sx={styles.errorText}>
                    {errorMessage}
                  </Typography>
                )}
              </>
            )}

            {getShopsIsLoading ? (
              <Spinner color={WHITE} size="sm" />
            ) : (
              <Box sx={styles.footer}>
                <Button
                  disabled={
                    errorMessage ||
                    getShopsIsLoading ||
                    displayIsSavingSpinner ||
                    (isForcedNewAddressForDelivery && !selectedAddress)
                  }
                  type={PRIMARY}
                  label={constructValidateButtonText(orderType)}
                  style={styles.btn}
                  onClick={() => handleValidationButtonClick()}
                  loading={displayIsSavingSpinner}
                  size="large"
                  width="100%"
                />
              </Box>
            )}
          </>
        )}
      </div>
    </div>
  );
}
